import { render, staticRenderFns } from "./R08.vue?vue&type=template&id=7e8d2f9a&"
import script from "./R08.vue?vue&type=script&lang=js&"
export * from "./R08.vue?vue&type=script&lang=js&"
import style0 from "./R08.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports